// extracted by mini-css-extract-plugin
module.exports = {"hideOnDesktop":"styles_hideOnDesktop__1VghE","hideOnTablet":"styles_hideOnTablet__1sA_F","hideOnMobile":"styles_hideOnMobile__1vD0M","priceColumn":"styles_priceColumn__3bOLs"};